export function Footer() {
  return (
    <footer className="border-t border-gray-800 bg-[#030712] px-6 py-6 text-center text-xs text-gray-500">
      © {new Date().getFullYear()} KeywordGod — built on Cloudflare. 키워드의 신.
    </footer>
  );
}
